<div>
    <h2 style="margin: 5px 0 10px 0;">Create a New Consumer</h2>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
        <div class="container">
            <div>
                <mat-form-field>
                    <input
                        matInput
                        required
                        placeholder="Consumer Name"
                        formControlName="name"
                    >
                    <mat-error *ngIf="form.controls['name'].invalid">Please enter a Name</mat-error>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <input
                        formControlName="tag"
                        matInput
                        pattern="^[A-Z_0-9]*$"
                        placeholder="Consumer Tag"
                        required
                        (focusout)="findTagExists()"
                    >
                    <mat-error *ngIf="form.controls['tag'].invalid && !form.controls['tag'].value">
                        Please enter a Standard Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.pattern && form.controls['tag'].value">
                        Please enter a Valid Standard Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.tagExists && form.controls['tag'].touched">
                        Tag already exists! Create a new one.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="container">
            <div>
                <mat-form-field>
                    <mat-select
                        placeholder="Consumer Type"
                        required
                        formControlName="destinationType"
                    >
                        <mat-option
                            *ngFor="let consumerType of (consumerTypes$ | async)"
                            [value]="consumerType.tag"
                        >
                            {{ consumerType.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['destinationType'].invalid">
                        Please select a Consumer Type
                    </mat-error>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-select
                        placeholder="Sales Channels"
                        required
                        multiple
                        formControlName="salesChannels">
                        <mat-option
                            [value]="'ORDERING'"
                            [disabled]="true">
                            In Store Price
                        </mat-option>
                        <mat-option
                            *ngFor="let channel of salesChannels"
                            [value]="channel.tag">
                            {{ channel.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="container">
            <mat-form-field class="flex-85" >
                    <textarea
                        formControlName="description"
                        matInput
                        matTextareaAutosize
                        placeholder="Consumer Description"
                        required
                        maxlength="250"
                    ></textarea>
                <mat-error *ngIf="form.controls['description'].invalid">
                    Please enter a Description
                </mat-error>
            </mat-form-field>
        </div>
        <div  style="margin-top: 30px;" class="flex-center-center">
            <button
                class="button-color"
                mat-raised-button
                matTooltip="Cancel Creating Consumer"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
            >Cancel
            </button>
            <button
                class="button-color"
                [disabled]="form.invalid"
                mat-raised-button
                matTooltip="Submit Consumer"
                type="submit"
            >Save
            </button>
        </div>
    </form>
</div>
